import { useEffect, useState } from 'react'

import axios from 'axios'

const CONSENT_PATH = '/api/internal/marketing-consent'

let consentRequest = null

export function resetExplicitMarketingConsentCache() {
  consentRequest = null
}

function fetchExplicitConsentRequired() {
  consentRequest = consentRequest
    || axios.get(CONSENT_PATH, { headers: { accept: 'application/json' }, withCredentials: true, timeout: 4000 })
      .then(response => response?.data?.explicit_consent_required !== false)
      .catch(() => true)

  return consentRequest
}

function useExplicitMarketingConsent() {
  const [explicitConsentRequired, setExplicitConsentRequired] = useState(null)

  useEffect(() => {
    let isMounted = true

    fetchExplicitConsentRequired().then((required) => {
      if (isMounted) setExplicitConsentRequired(required)
    })

    return () => { isMounted = false }
  }, [])

  return explicitConsentRequired
}

export default useExplicitMarketingConsent
